/**
 * Utility functions for unit conversions and other shared functionality
 */

/**
 * Helper function to convert a value from one unit to another
 * @param value - The numeric value to convert
 * @param fromUnit - The source unit (meters, centimeters, millimeters, inches, feet, yards)
 * @param toUnit - The target unit (meters, centimeters, millimeters, inches, feet, yards)
 * @returns The converted value in the target unit
 */
export const convertLengthValue = (value: number, fromUnit: string, toUnit: string): number => {
  // Define conversion factors relative to meters (base unit)
  const toMeters: Record<string, number> = {
    meters: 1,
    centimeters: 0.01,
    millimeters: 0.001,
    inches: 0.0254,
    feet: 0.3048,
    yards: 0.9144,
  };

  const fromMeters: Record<string, number> = {
    meters: 1,
    centimeters: 100,
    millimeters: 1000,
    inches: 39.3701,
    feet: 3.28084,
    yards: 1.09361,
  };

  // Convert value to meters first, then to target unit
  const valueInMeters = value * toMeters[fromUnit.toLowerCase()];
  return valueInMeters * fromMeters[toUnit.toLowerCase()];
};

// Export a default object with all utility functions
const utils = {
  convertLengthValue,
};

export default utils;
